import React, { createContext, useContext, useState } from "react";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [trigger, setTrigger] = useState(false);
    const refreshData = () => {
        setTrigger((prev) => !prev);
    };

    return (
        <DataContext.Provider value={{ trigger, refreshData }}>
            {children}
        </DataContext.Provider>
    );
};

export const useDataContext = () => {
    return useContext(DataContext);
};
